/**
 * Generic lightbox utility for auction hub info lightboxes.
 * Replaces 3 copies of identical open/close/popstate boilerplate.
 *
 * Creates global functions: openXxxLightbox(), closeXxxLightbox(), closeXxxLightboxOnOutsideClick()
 * Handles Android back button via history.pushState/replaceState.
 */
(function() {
  'use strict';

  function createInfoLightbox(elementId, name) {
    var state = { isOpen: false, previousHistoryState: null };

    var openFn = function() {
      var el = document.getElementById(elementId);
      if (!el) return;
      el.style.display = 'flex';
      state.isOpen = true;
      state.previousHistoryState = window.history.state;
      window.history.pushState({ lightbox: name }, '');
    };

    var closeFn = function() {
      var el = document.getElementById(elementId);
      if (!el) return;
      if (el.style.display === 'none') return;
      el.style.display = 'none';
      state.isOpen = false;
      window.history.replaceState(state.previousHistoryState, '');
    };

    var outsideClickFn = function(event) {
      if (event.target === document.getElementById(elementId)) {
        closeFn();
      }
    };

    // Handle Android back button
    window.addEventListener('popstate', function() {
      if (state.isOpen) closeFn();
    });

    // Expose globally for onclick handlers in Liquid HTML
    window['open' + name + 'Lightbox'] = openFn;
    window['close' + name + 'Lightbox'] = closeFn;
    window['close' + name + 'LightboxOnOutsideClick'] = outsideClickFn;
  }

  // Register all info lightboxes
  createInfoLightbox('hub-info-lightbox', 'HubInfo');
  createInfoLightbox('lightbox-absentee-info', 'AbsenteeInfo');
  createInfoLightbox('minimumbid-info-lightbox', 'MinimumBid');
})();
